function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M8.5 19a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm9 0a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM3 2h2a1 1 0 01.965.738l.023.11L6.473 6H21a1 1 0 01.995 1.1l-.019.117-1.652 7.434a3 3 0 01-2.746 2.343l-.182.006h-8.68a3 3 0 01-2.933-2.37l-.032-.174L4.142 4H3a1 1 0 01-.117-1.993L3 2h2-2zm16.753 6H6.781l.946 6.152a1 1 0 00.876.842l.113.006h8.68a1 1 0 00.944-.671l.032-.112L19.753 8z"
});

function SvgCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref);
}

export default SvgCart;